module.exports = __webpack_public_path__ + "static/media/mandarmani.e216e181.jpg";